import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentFaFunctionSubcategory on FaFunctionSubcategory {
    id
    code
    name
    isUtilityRelated
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentFaFunctionSubcategoryFragment,
  ents.extra.common.FaFunction.Subcategory
>({
  code: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.common.FaFunction.Subcategory.Id.assertIsId,
    { warnOnly: true },
  ),
  isUtilityRelated: graphql.transformers.OUT.default(
    transformers.PASS_THROUGH,
    false,
  ),
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
})
